import { defineComponent as C, computed as s, useAttrs as p, createElementBlock as l, createCommentVNode as y, openBlock as n, createElementVNode as b, normalizeClass as v, Fragment as L, renderList as I, mergeProps as g, renderSlot as h } from "vue";
import { tw as k } from "../../utils/tailwind.js";
import { fluidLayoutListClass as A, fluidLayoutCardClass as N } from "./helpers/fluidLayout.helpers.js";
import { gridLayoutListClass as O, gridLayoutCardClass as S } from "./helpers/gridLayout.helpers.js";
import { responsiveLayoutListClass as _, responsiveLayoutCardClass as j } from "./helpers/responsiveLayout.helpers.js";
const x = ["aria-label", "aria-labelledby"], z = /* @__PURE__ */ C({
  name: "RevCardGrid",
  __name: "CardGrid",
  props: {
    cards: {},
    ariaLabel: { default: void 0 },
    ariaLabelledby: { default: void 0 },
    layout: { default: "grid" }
  },
  setup(u) {
    const o = u, a = s(() => o.cards.length), i = s(() => {
      const e = p();
      return Object.keys(e).filter((t) => t.match(/^on[A-Z]+/)).reduce((t, r) => ({ ...t, [r]: e[r] }), {});
    });
    function c(e) {
      return JSON.stringify(e);
    }
    const f = s(() => {
      const e = k`grid list-none gap-12`;
      return o.layout === "fluid" ? [e, ...A(a.value)] : o.layout === "responsive" ? [e, ..._(a.value)] : [e, O()];
    });
    function m(e) {
      return e.layout === "fluid" ? N({
        cardIndex: e.cardIndex,
        cardsCount: e.cardsCount
      }) : e.layout === "responsive" ? j({
        cardIndex: e.cardIndex,
        cardsCount: e.cardsCount
      }) : S({
        cardIndex: e.cardIndex,
        cardsCount: a.value
      });
    }
    return (e, t) => e.cards.length ? (n(), l("nav", {
      key: 0,
      "aria-label": e.ariaLabel,
      "aria-labelledby": e.ariaLabelledby
    }, [
      b("ul", {
        class: v(f.value)
      }, [
        (n(!0), l(L, null, I(e.cards, (r, d) => (n(), l("li", g({
          key: c(r),
          class: m({
            cardIndex: d,
            cardsCount: a.value,
            layout: e.layout
          })
        }, { ref_for: !0 }, i.value), [
          h(e.$slots, "default", {
            card: r,
            index: d
          })
        ], 16))), 128))
      ], 2)
    ], 8, x)) : y("", !0);
  }
});
export {
  z as default
};
